var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10918 3.32083C2.10918 3.81789 2.51212 4.22083 3.00918 4.22083H3.3457H14.4321H14.7685C15.2656 4.22083 15.6685 3.81789 15.6685 3.32083V2.1C15.6685 1.60294 15.2656 1.2 14.7685 1.2H3.00918C2.51212 1.2 2.10918 1.60294 2.10918 2.1V3.32083ZM15.0321 5.40445C16.0675 5.2748 16.8685 4.39136 16.8685 3.32083V2.1C16.8685 0.940201 15.9283 0 14.7685 0H3.00918C1.84938 0 0.90918 0.940202 0.90918 2.1V3.32083C0.90918 4.39139 1.71027 5.27485 2.7457 5.40446V13.399C2.7457 14.8349 3.90976 15.999 5.3457 15.999H12.4321C13.868 15.999 15.0321 14.8349 15.0321 13.399V5.40445ZM13.8321 5.42083H3.9457V13.399C3.9457 14.1722 4.5725 14.799 5.3457 14.799H12.4321C13.2053 14.799 13.8321 14.1722 13.8321 13.399V5.42083ZM7.66353 8.24154C7.66353 7.91017 7.3949 7.64154 7.06353 7.64154C6.73216 7.64154 6.46353 7.91017 6.46353 8.24154V11.9782C6.46353 12.3096 6.73216 12.5782 7.06353 12.5782C7.3949 12.5782 7.66353 12.3096 7.66353 11.9782V8.24154ZM10.7132 7.64154C11.0446 7.64154 11.3132 7.91017 11.3132 8.24154V11.9782C11.3132 12.3096 11.0446 12.5782 10.7132 12.5782C10.3818 12.5782 10.1132 12.3096 10.1132 11.9782V8.24154C10.1132 7.91017 10.3818 7.64154 10.7132 7.64154Z",
    fill: "#EE0202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAdminIcon);
export default __webpack_public_path__ + "static/media/delete-admin-icon.c6036740.svg";
export { ForwardRef as ReactComponent };